import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent, WmsToggleComponent} from "@wms/components";
import {LiveWidgetSettingsService} from "@wms/app/services/liveWidgetsSettings/live-widget-settings.service";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {FormsModule} from "@angular/forms";
import {EventHandlerComponent} from "@wms/properties-panel";
import {set, toString} from "lodash-es";
import { WmsExpressionErrorDirective } from '@wms/app/directives/wms-expression-error/wms-expression-error.directive';

@Component({
  selector: 'wms-row',
  standalone: true,
  imports: [CommonModule, WmsToggleComponent, TooltipModule, FormsModule, EventHandlerComponent, WmsExpressionErrorDirective],
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.less']
})
export class RowComponent extends BaseComponent{

  @Output() contentChange = new EventEmitter<any>();
  @Input() liveWidgetSettingsService: LiveWidgetSettingsService;
  show: boolean;
  disabled: boolean;
  closeOthers: boolean;
  convertToString = toString;
  constructor() {
    super();
  }

  showHideSubgroups() {
    this.liveWidgetSettingsService.componentDefnObject.enableRowExpansion = (this.liveWidgetSettingsService.componentDefnObject.enableRowExpansion === 'true')? 'false': 'true';
  }

  onToggle(property: string, value: boolean){
    set(this.liveWidgetSettingsService.componentDefnObject.rowDef, property, value);
  }

}
